import { differenceInDays, endOfMonth } from 'date-fns';
import { useMemo } from 'react';

export const useDaysRemainingInMonth = () => {
	const daysRemaining = useMemo(() => {
		const today = new Date();
		return differenceInDays(endOfMonth(today), today);
	}, []);

	return daysRemaining;
};
